import React, { useState } from "react";

const AlertManager = () => {
   return (<></>)
};

export default AlertManager;
